<app-topnav></app-topnav>
<main class="inner-content">
    <div class="container-fluid">
        <app-upcoming *ngIf="!router.url.includes('casino-detail')"></app-upcoming>
        <div class="row">
            <div class="col-md-2 px-lg-1" *ngIf="!router.url.includes('casino-detail')">
                <app-sidebar></app-sidebar>
            </div>
            <div class="px-1" [ngClass]="(router.url.includes('casino-detail'))?'col-md-12':'col-md-10'">
                <router-outlet></router-outlet>
            </div>

        </div>
    </div>
</main>
<app-footer *ngIf="!router.url.includes('casino-detail')"></app-footer>